
































































import { Component, Prop, Mixins } from "vue-property-decorator";
import FormDialog from "@/components/FormDialog.vue";
import * as types from '@/lib/definition/types'
import { Endpoints } from "@octokit/types";
import BasicTs from "./mixins/basicts.vue";

@Component({ components: { FormDialog },
  mixins: [BasicTs] })
export default class ChangeProjectDialog extends Mixins(BasicTs) {
  private current: types.ChangeProjectParam = this.$store.direct.getters.PersonalTime.emptyChangeProjectParam
  private projects = Array<types.ChangeProjectParamProject>()
  private repositories = Array<types.ChangeProjectParamProjectRepository>()
  private issues: Endpoints["GET /repos/{owner}/{repo}/issues"]["response"]["data"] = []
  private issueType = 0
  @Prop() private showDialog!: boolean;
  @Prop({default: null}) private targetDate!: string|null;
  @Prop({default: null}) private issueToEdit!: types.ProjectReportByProject|null;

  async mounted() {
    if (this.issueToEdit?.personalTimeDayProjectIssueId != null) {
      this.current = await this.$store.direct.dispatch.PersonalTime.getChangeProjectParamForIssue(this.issueToEdit?.personalTimeDayProjectIssueId)
    } else {
      this.current = await this.$store.direct.dispatch.PersonalTime.getChangeProjectParam()
    }
    this.projects = this.current.projects
    var selectedProject = this.projects.reduce((prev: types.ChangeProjectParamProject | null, current) => { return prev != null ? prev : (current.projectId == this.current.projectId ? current : null )}, null)
    this.repositories = selectedProject == null ? [] : selectedProject.repositories
    await this.search()
  }
  async search() {
    try {
      var selectedRepository = this.repositories.reduce((prev: types.ChangeProjectParamProjectRepository | null, current) => { return prev != null ? prev : (current.projectRepositoryId == this.current.projectRepositoryId ? current : null )}, null)
      if (selectedRepository != null) {
        this.issues = await this.$store.direct.dispatch.PersonalTime.getGithubRepositoryIssues({org: selectedRepository.organzationName, repo: selectedRepository.repositoryName,state: (this.issueType == 0? "open" : "closed")})
        if (this.current.issueNumber != null && this.issues.reduce((prev: boolean, obj) => { return prev || obj.number == this.current.issueNumber }, false) == false) {
          this.issueType = this.issueType == 0 ? 1 : 0;
          this.issues = await this.$store.direct.dispatch.PersonalTime.getGithubRepositoryIssues({org: selectedRepository.organzationName, repo: selectedRepository.repositoryName,state: (this.issueType == 0? "open" : "closed")})
        }
      }
    } catch {
      this.dispError('Github連携に失敗しました。ユーザーページから連携してください')
    }
  }
  updateIssueName(item: any) {
    var selectedIssue = this.issues.reduce((prev: any | null, current) => { return prev != null ? prev : (current.number == item ? current : null )}, null)
    this.current.issueName = selectedIssue?.title
    this.current.milestoneId = selectedIssue?.milestone?.id
    this.current.milestoneTitle = selectedIssue?.milestone?.title
  }
  async submit() {
    this.updateIssueName(this.current.issueNumber)
    if (this.issueToEdit != null) {
      var updateParam: types.UpdateIssueParam = {
        personalTimeDayProjectIssueId: this.issueToEdit.personalTimeDayProjectIssueId,
        appUserId: this.current.appUserId,
        projectId: this.current.projectId,
        projectRepositoryId: this.current.projectRepositoryId,
        issueNumber: this.current.issueNumber,
        note: this.current.note,
        issueName: this.current.issueName,
        milestoneId: this.current.milestoneId,
        milestoneTitle: this.current.milestoneTitle
      }
      await this.$store.direct.dispatch.PersonalTime.updateProjectIssue(updateParam)
    } else if (this.targetDate == null) {
      await this.$store.direct.dispatch.PersonalTime.makeActive(this.current)
    } else {
      await this.$store.direct.dispatch.PersonalTime.addProjectForDate({param: this.current, date: this.targetDate})
    }
    this.close()
  }
  close() {
    this.$emit('close')
  }
  async makeActive(selectedObj : types.ChangeProjectParamProject) {
    if (this.current.projectId != selectedObj.projectId) {
      this.current.projectId = selectedObj.projectId
      this.repositories = selectedObj.repositories
      this.current.projectRepositoryId = this.repositories.reduce((prev: string | null, obj) => { return prev != null ? prev : obj.projectRepositoryId }, null)
      this.current.issueNumber = null
      this.search()
    }
  }
  async makeActiveRepository(selectedObj : types.ChangeProjectParamProjectRepository) {
    if (this.current.projectRepositoryId == selectedObj.projectRepositoryId) {
      this.current.projectRepositoryId = null
    } else {
      this.current.projectRepositoryId = selectedObj.projectRepositoryId
    }
    this.current.issueNumber = null
    this.search()
  }
  async issueTypeChanged() {
    this.current.issueNumber = null
    this.search()
  }
  filterIssue(item: any, queryText: string, itemText: string) {
    return (
      item.number.toString().indexOf(queryText.toLocaleLowerCase()) > -1 
      || item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      || item.assignee?.login.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    );
  }
  get dialog() {
    return this.showDialog;
  }
  set dialog(value) {
    this.$emit("update:showDialog", value);
  }
}
